import { HTTP_METHODS } from '@studio/constants/axios';
import { MEDIA_METADATA_API_V1 } from '@studio/constants/env-variables';
import type { Events } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/contentdestinations/@contentDestinationId/archive`,
    request: {} as Events.Post.AddMediaMetaDataArchive,
    response: {} as Events.Post.Response.MediaMetadataArchive,
    params: {} as { contentDestinationId: string },
    method: HTTP_METHODS.POST,
  },
};
